/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import nodeLogo from '@/assets/dash0-logo.png'

// const handleStyle = { height: 120 };

function Dash0NodeDT({ data, isConnectable }) {
  return (
    <div className="custom-node-wbg cloud-limits">
      <Handle type="target" position={Position.Top} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            {/* <a href="https://app.dash0.com/" target="_blank" rel="noreferrer"> */}
            <img src={nodeLogo} alt="Logo" />
            {/* </a> */}
          </div>
          <div className="text-center mt-4">
            <b>Observability Platform</b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dash0NodeDT
